"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = require("classnames");
var react_1 = require("react");
var theme_1 = require("../../theme");
var common_utils_1 = require("../../tools/common-utils");
var buttons_1 = require("../buttons");
var colors = {
    victor: (0, classnames_1.default)("\n              focus:squid-border-alias-color-victor-border-active\n              focus:squid-bg-alias-state-victor-base-active\n              focus-visible:squid-border-alias-color-victor-border-active\n              focus-visible:squid-bg-alias-state-victor-base-active\n            "),
    wawanesa: (0, classnames_1.default)("\n              focus:squid-border-alias-color-wawanesa-border-active\n              focus:squid-bg-alias-state-wawanesa-base-active\n              focus-visible:squid-border-alias-color-wawanesa-border-active\n              focus-visible:squid-bg-alias-state-wawanesa-base-active\n            "),
    base: (0, classnames_1.default)("\n              focus:squid-border-alias-color-border-active\n              focus:squid-bg-alias-state-base-active\n              focus-visible:squid-border-alias-color-border-active\n              focus-visible:squid-bg-alias-state-base-active\n            "),
};
var YearPickerContent = function (_a) {
    var value = _a.value, show = _a.show, onChange = _a.onChange, forwardedRef = _a.forwardedRef, disableYearsBefore = _a.disableYearsBefore, disableYearsAfter = _a.disableYearsAfter;
    var branding = ((0, theme_1.useSquidStyles)() || {}).branding;
    var _b = (0, react_1.useState)(value), year = _b[0], setYear = _b[1];
    var yearsRefs = (0, react_1.useRef)([]);
    var containerRef = (0, react_1.useRef)(null);
    var years = (0, react_1.useMemo)(function () { return (0, common_utils_1.range)(1900, disableYearsAfter || (year || value || 2023) + 70); }, [year, value]);
    var isClicked = (0, react_1.useCallback)(function (target) { var _a; return (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.contains(target); }, []);
    var focus = (0, react_1.useCallback)(function () {
        var _a, _b;
        var index = years.findIndex(function (y) { return y === year; });
        (_b = (_a = yearsRefs.current) === null || _a === void 0 ? void 0 : _a[index < 0 ? 0 : index]) === null || _b === void 0 ? void 0 : _b.focus();
    }, []);
    (0, react_1.useImperativeHandle)(forwardedRef, function () { return ({ isClicked: isClicked, focus: focus }); });
    var scrollToSelected = (0, react_1.useCallback)(function (to) {
        var _a, _b;
        var index = years.findIndex(function (y) { return y === (to || year); });
        (_b = (_a = yearsRefs.current) === null || _a === void 0 ? void 0 : _a[index]) === null || _b === void 0 ? void 0 : _b.scrollIntoView({ behavior: 'smooth' });
    }, []);
    (0, react_1.useEffect)(function () {
        if (show) {
            scrollToSelected(year);
        }
    }, [year, show, scrollToSelected]);
    var handleSelect = function (y) { return function () {
        setYear(y);
        onChange === null || onChange === void 0 ? void 0 : onChange(y);
        scrollToSelected(y);
    }; };
    var handleYearItemKeyDown = function (y, index) { return function (e) {
        var _a;
        var lastIndex = yearsRefs.current.length - 1;
        switch (e.key) {
            case 'Enter':
                handleSelect(y)();
                break;
            case 'ArrowLeft':
            case 'ArrowUp': {
                e.preventDefault();
                yearsRefs.current[index - 1].focus();
                setYear(y - 1);
                scrollToSelected(y - 1);
                break;
            }
            case 'ArrowRight':
            case 'ArrowDown': {
                e.preventDefault();
                var nextIndex = index < lastIndex ? index + 1 : 0;
                yearsRefs.current[nextIndex].focus();
                setYear(index < lastIndex ? year + 1 : year);
                scrollToSelected(index < lastIndex ? year + 1 : year);
                break;
            }
            case 'Tab':
                if (e.shiftKey) {
                    if (index === 0) {
                        e.preventDefault();
                        yearsRefs.current[lastIndex].focus();
                    }
                }
                else {
                    if (index === lastIndex) {
                        e.preventDefault();
                        yearsRefs.current[0].focus();
                    }
                }
                break;
            default:
                break;
        }
        (_a = yearsRefs.current[index]) === null || _a === void 0 ? void 0 : _a.blur();
    }; };
    var checkDisabled = (0, react_1.useCallback)(function (y) {
        return ((disableYearsBefore || 0) > 0 && y < disableYearsBefore) ||
            ((disableYearsAfter || 0) > 0 && y > disableYearsAfter);
    }, [disableYearsAfter, disableYearsBefore]);
    return ((0, jsx_runtime_1.jsx)("div", __assign({ ref: containerRef, className: (0, classnames_1.default)('squid-mt-2 squid-grid squid-items-center squid-grid-cols-4 squid-w-full squid-max-h-60 squid-gap-2 squid-overflow-y-auto', { 'squid-hidden': !show }) }, { children: years.map(function (y, index) {
            var disabled = checkDisabled(y);
            return ((0, jsx_runtime_1.jsx)("div", __assign({ ref: function (ref) {
                    yearsRefs.current[index] = ref;
                }, onClick: disabled ? undefined : handleSelect(y), onKeyDown: disabled ? undefined : handleYearItemKeyDown(y, index), className: (0, classnames_1.default)("\n              focus:squid-border\n              focus-visible:squid-border\n            ", colors[branding || 'base']) }, { children: (0, jsx_runtime_1.jsx)(buttons_1.SimpleButton, { title: y.toString(), active: y === year, "aria-label": y.toString(), tabIndex: 0, disabled: disabled }) }), y.toString()));
        }) })));
};
exports.default = YearPickerContent;
